<div class="help">Some help here.</div>

<style>
  .help {
    padding: 20px;
  }
</style>
